import React from 'react'

import PlanList from 'ui/components/plan/PlanList'

export default function ({ docType }) {
  return (
    <PlanList
      docType={docType}
      showBtnCreate={true}
      showBtnDelete={true}
      showBtnEdit={true}
      showBtnView={true}
      showBtnUserDefineDefaultPlan={true}
    />
  )
}
